import { Skeleton, Tag } from 'antd'
import { SGeneralForms } from 'shj-components'
import { useEffect, useRef, useState } from 'react'
import { useCustomerInfo } from '@/hooks/useCustomerInfo'
import dayjs from 'dayjs'

const UserInfoTop = () => {
  const formRef = useRef<any>()
  const { customerInfo, loading } = useCustomerInfo()
  const [tagList, setTagList] = useState<any[]>([])

  const tagColorList = [
    'rgba(250, 96, 80, 1)',
    'rgba(0, 100, 255, 1)',
    'rgba(245, 147, 0, 1)',
    'rgba(112, 163, 16, 1)',
  ]

  useEffect(() => {
    if (customerInfo?.id) {
      formRef.current?.onFormRef().setFieldsValue({
        id: customerInfo?.id,
        pin: customerInfo?.pin ? customerInfo.pin : '',
        orgNames: customerInfo?.orgNames ? customerInfo.orgNames?.join('；') : '',
        lastFollowTime: customerInfo?.lastFollowTime
          ? dayjs(customerInfo.lastFollowTime).format('YYYY-MM-DD HH:mm:ss')
          : '',
      })
      setTagList(customerInfo?.tags || [])
    }
  }, [
    customerInfo?.id,
    customerInfo?.lastFollowTime,
    customerInfo?.orgNames,
    customerInfo?.pin,
    customerInfo?.tags,
  ])

  return (
    <>
      <Skeleton
        loading={loading}
        active
        style={{
          backgroundColor: '#fff',
          padding: '20px 20px 0 20px',
          width: '65vw',
        }}
      >
        <div
          style={{
            backgroundColor: '#fff',
            display: 'flex',
            flexDirection: 'column',
            padding: '20px 20px 0 20px',
            width: '65vw',
          }}
        >
          <span style={{ fontSize: 16, fontWeight: 600 }}>{customerInfo?.name}</span>
          <div style={{ display: 'flex', gap: 3, marginTop: 20, flexWrap: 'wrap' }}>
            {tagList.length > 0 ? (
              tagList.map((item, index) => (
                <Tag color={tagColorList[index % 4]} key={item.tagId}>
                  {item.tagName}
                </Tag>
              ))
            ) : (
              <Tag>无标签</Tag>
            )}
          </div>
          <div>
            <SGeneralForms
              ref={formRef}
              layout={'horizontal'}
              isDetail={true}
              configs={[
                {
                  formItem: [
                    { label: '客户编号', name: 'id', spanCol: 6 },
                    { label: 'JDPIN', name: 'pin', spanCol: 6 },
                    { label: '所属门店', name: 'orgNames', spanCol: 6 },
                    { label: '最近跟进日期', name: 'lastFollowTime', spanCol: 6 },
                  ],
                },
              ]}
            />
          </div>
        </div>
      </Skeleton>
    </>
  )
}

export default UserInfoTop
